<div fxLayout="row">
    <h6 class="filter-title" fxFlex>Analysis options</h6>
</div>
<div fxLayout="row" class="analysis-row">
    <div *ngFor="let option of analysisOptions; let i = index">
        <ng-container *ngIf="!(hideMeasurementOption && option.id === 2)">
            <input type="radio" class="analysis-option" name="analysisOptions" [value]="option.id" [checked]="analysisOptionId === option.id" (change)="onUserAnalysisOptionChange(option.id)" />
            <span class="analysis-option-span">{{ option.name }}</span>
        </ng-container>
    </div>
</div>

<div fxLayout="row" class="analysis-row">
    <div *ngIf="analysisOptionId === 2">
        <select [(ngModel)]="selectedSummaryStatisticsId" id="summaryStatistics" class="single-select-dropdown" (ngModelChange)="onSummaryStatisticsChange($event)">
            <ng-container *ngFor="let option of summaryStatisticFilteredList">
                <option [ngValue]="option.id">
                    {{ option.name }}
                </option>
            </ng-container>
        </select>
    </div>
</div>
